<script setup>
import SectionTitle from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/SectionTitle.vue'

const props = defineProps({
  id: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    default: ''
  },
  lat: {
    type: String,
    default: ''
  },
  lon: {
    type: String,
    default: ''
  }
})

const { data: results } = await useAsyncData(
  `riverAroundCam-${props.lat}-${props.lon}-${props.id}`,
  () => $fetch('/api/river/aroundcam', {
    query: { lat: props.lat, lon: props.lon, id: props.id }
  }),
  { watch: [() => props.lat, () => props.lon, () => props.id] }
)
</script>

<template>
  <section
    v-if="results.length > 0"
    class="livecamRowList"
  >
    <SectionTitle
      :title="`${title}周辺の河川ライブカメラ`"
    />
    <ul class="content">
      <li
        v-for="content in results"
        :key="content.text"
      >
        <RiverBlock
          :text="content.text"
          :link="content.link"
          :date="content.latest"
          :img="content.image"
        />
      </li>
    </ul>
  </section>
</template>

<style scoped>
.livecamRowList {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  .content {
    display: flex;
    gap: 6px;
    overflow-x: scroll;
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 8px;
      background-color: #fff;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 8px;
      background: #438fec;
    }
    li {
      width: calc((100% - 12px) / 3);
      min-width: 153px;
    }
  }
}
</style>
